export enum UserStatus{
    ACTIVE = "Active",
    INACTIVE = "Inactive",
}